import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { checkUser, getDefaultRoutes } from './Login/login.async'

const initialState = {
  isLoggedIn: false,
  user: null,
  company: null,
  defaultRoute: null,
  fetchingUserLoader: false,
  fetchingDefRouteLoader: false,
  initialize: false,
  displayMessage: null,
  routeToNavigate: null
}

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(checkUser.pending), (state) => {
      state.fetchingUserLoader = true
    })
    builder.addMatcher(isAnyOf(checkUser.fulfilled), (state, action) => {
      state.isLoggedIn = true
      state.fetchingUserLoader = false
    })
    builder.addMatcher(isAnyOf(checkUser.rejected), (state, action) => {
      state.fetchingUserLoader = false
      state.initialize = false
      state.displayMessage = { message: 'Unable to Login. Please try again.', type: 'error' }
    })
    builder.addMatcher(isAnyOf(getDefaultRoutes.pending), (state) => {
      state.fetchingDefRouteLoader = true
    })
    builder.addMatcher(isAnyOf(getDefaultRoutes.fulfilled), (state, action) => {
      state.fetchingDefRouteLoader = false
      state.defaultRoute = action.payload.defaultRoute[0]?.config_path ?? '/home'
    })
    builder.addMatcher(isAnyOf(getDefaultRoutes.rejected), (state, action) => {
      state.fetchingDefRouteLoader = false
      state.initialize = false
      state.loginError = { message: 'Unable to Login. Please try again.', type: 'error' }
    })
  },
  reducers: {
    login: (state, action) => {
      state.isLoggedIn = true
      state.defaultRoute = action.payload
    },
    setUser: (state, action) => {
      state.user = action.payload
    },
    setDisplayMessage: (state, action) => {
      state.displayMessage = action.payload
    },
    setRouteToNavigate: (state, action) => {
      state.routeToNavigate = action.payload
    },
    setInitialize: (state, action) => {
      state.initialize = action.payload
    },
    logout: (state) => {
      state.isLoggedIn = false
      state.user = null
      state.company = null
    },
  },
})

export const { login, setCompany, setUser, logout, setInitialize, setDisplayMessage, setRouteToNavigate } =
  loginSlice.actions

export default loginSlice.reducer
